export enum IndexTag {
	BlogPost = "BlogPost",
	Category = "Category",
	Product = "Product",
	CaseStudy = "CaseStudy",
	Podcast = "Podcast",
}
